import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Mapper } from '@core/services/mapper/base-mapper.mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiConstant } from '@shared/constants/api.constant';
import { Receiver } from '@features/receivers/models/receiver';
import { ReceiverType } from "@shared-features/enums/receiver-type.enum";
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { ExportedFile } from '@shared-features/models/exported-file';

@Injectable({
  providedIn: 'root',
})
export class ReceiversApiService {
  constructor(private baseAPI: ApiBaseService, private mapper: Mapper) {}

  // receivers
  updateReceiver(receiver: Receiver, receiverType: ReceiverType, locationIds: number[], customerId?: number): Observable<Receiver> {
    const body = filterNullEntity({
      id: receiver.id,
      customerId,
      name: receiver?.name,
      receiverType,
    });

    if (receiver.contactPerson.length) {
      receiver.contactPerson.forEach((contact) => {
        for (let propName in contact) {
          if (!contact[propName]) {
             contact[propName] = null;
          }
        }
      });

      body['contactPerson'] = receiver.contactPerson;
    }
    if (locationIds?.length) body['locationIds'] = locationIds;

    return this.baseAPI.put(ApiConstant.UPDATE_RECEIVER, body).pipe(
      map((res) => {
        return this.mapper.fromJson(Receiver, res.data);
      })
    );
  }

  exportRecivers(receiverType: ReceiverType, customerId?: number): Observable<ExportedFile> {
    const params = filterNullEntity({
      receiverType,
      customerId,
    });
    return this.baseAPI.post(ApiConstant.API_EXPORT_RECEIVERS, null, { params }).pipe(
      map((res) => {
        return this.mapper.fromJson(ExportedFile, res.data);
      })
    );
  }
}
